import { render, staticRenderFns } from "./CornerRightBottom.vue?vue&type=template&id=bc8788b2&scoped=true&"
import script from "./CornerRightBottom.vue?vue&type=script&lang=js&"
export * from "./CornerRightBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8788b2",
  null
  
)

export default component.exports